module.exports = __webpack_public_path__ + "assets/img/wallpaper-2.241150e3.jpg";